export default {
      id: "im-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "sprite-46b249.svg#im-usage",
      toString: function () {
        return this.url;
      }
    }